export default __webpack_public_path__ + "static/media/accessories.76d35e0d.jpg";